export default {
      id: "ic_no_coupon-usage",
      viewBox: "0 0 71 70",
      url: "/" + "images/icons.3.109.2.svg#ic_no_coupon-usage",
      toString: function () {
        return this.url;
      }
    }